import { Button } from 'antd';
import { getGetPropostaQueryKey } from 'client/api/backend/procedimenti/procedimenti';
import { appConfig } from 'client/core/appConfig';
import { joinPath } from 'client/core/network/joinPath';
import React, { useMemo } from 'react';

interface IProcedureDocumentProposalButtonProps {
  procedureId: string;
  documentId: string | undefined;
}

export function ProcedureDocumentProposalButton(
  props: IProcedureDocumentProposalButtonProps
) {
  const { procedureId, documentId: fileId } = props;

  const path = useMemo(
    () => getGetPropostaQueryKey(procedureId, fileId ?? '<undefined>')[0],
    [procedureId, fileId]
  );

  if (!fileId) {
    return null;
  }

  return (
    <a
      target="_blank"
      href={joinPath([appConfig.remotePath, appConfig.apiBackendPath, path])}
    >
      <Button size="large" type="primary">
        Visualizza Proposta
      </Button>
    </a>
  );
}
